// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2889(props) {
    return (
        <svg
            id="_x32_889"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.002;}\n"
                }
            </style>
            <g id="STL">
                <g id="compass">
                    <path
                        className="st0"
                        d="M233.7,205.5l-7.8-4.8l-4.9-6.4l7,3.9L233.7,205.5z"
                    />
                    <path
                        className="st1"
                        d="M238.7,209.7c-5.6,6.5-15.4,7.1-21.9,1.5s-7.1-15.4-1.5-21.9s15.4-7.1,21.9-1.5 C243.6,193.4,244.3,203.2,238.7,209.7z M216.3,190.2c-5.1,5.9-4.5,14.9,1.4,20s14.9,4.5,20-1.4s4.5-14.9-1.4-20 S221.4,184.3,216.3,190.2z"
                    />
                    <path
                        className="st0"
                        d="M226.8,196.6c1.6-0.1,3.1,1.1,3.2,2.8c0.1,1.6-1.1,3.1-2.8,3.2c-1.6,0.1-3.1-1.1-3.2-2.8 C223.9,198.1,225.2,196.7,226.8,196.6z M219.2,194.4l-2.3-2l0.3-0.4l2.5,0.3l-1.6-1.4l0.3-0.4l2.3,2l-0.3,0.4l-2.5-0.3l1.6,1.4 L219.2,194.4z"
                    />
                    <path
                        className="st2"
                        d="M226.9,197.9c0.9-0.1,1.7,0.6,1.8,1.5s-0.6,1.7-1.5,1.8s-1.7-0.6-1.8-1.5C225.3,198.7,226,197.9,226.9,197.9z "
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        transform="matrix(1 0 0 1 219.8574 119)"
                        className="st3 st4 st5"
                    >
                        335
                    </text>
                    <text
                        id="right-center_1_"
                        transform="matrix(1 0 0 1 43.833 58.0244)"
                        className="st3 st4 st5"
                    >
                        375
                    </text>
                    <text
                        id="center"
                        transform="matrix(1 0 0 1 116.0986 34.3447)"
                        className="st3 st4 st5"
                    >
                        400
                    </text>
                    <text
                        id="left-center_1_"
                        transform="matrix(1 0 0 1 188.0674 58.0244)"
                        className="st3 st4 st5"
                    >
                        375
                    </text>
                    <text
                        id="left"
                        transform="matrix(1 0 0 1 9.043 115.0767)"
                        className="st3 st4 st5"
                    >
                        336
                    </text>
                </g>
                <g id="field_1_">
                    <path
                        id="Outfield_1_"
                        className="st6"
                        d="M223.8,107.4l-14.2,14.2l-0.4,6.9l-29.9,52c0,0-18.3,18.4-24.2,25 c-4.4,5.4-15.6,18.5-29.5,18.5c-12.4,0-20.5-8.2-29.4-18.5L62,171.3l-8.4-37L28.2,108l-1.9-3.6l-1-4.6v-3.6l1.8-1.8l1.8-1.8 l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.8-1.8l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l1.9-1.9l2-2l2-2l2-2l2-2l2.1-2.1 l2.1-2.1l2.1-2.1l2.1-2.1l2.2-2.2l2.3-2l2.6-1l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.7-0.9l2.8-0.9l2.8-0.9 l2.8-0.9l2.8-0.9l2.8-0.9l2.9-0.1h26.1l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.8,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9l2.7,0.9 l2.7,0.9l2.7,0.9l2.7,1l2.3,1.9l2.2,2.2l2.1,2.1l2.1,2.1l2.1,2.1l2.1,2.1l2,2l2,2l2,2l2,2l1.9,1.9l1.9,1.9l1.9,1.9l1.9,1.9 l1.9,1.9l1.9,1.9l1.9,1.9l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.8,1.8l1.1,2.6l0.5,3.2l0.4,3.1l0.4,3.1L223.8,107.4L223.8,107.4z"
                    />
                    <path
                        id="grass_1_"
                        className="st3"
                        d="M125.6,215.8c-8,0-17.8-9-27.8-20.2L69,167.5l-9.7-39.4L38.8,107l-1.9-11.1l38.5-38.4l1-0.9 l1.1-0.4l34.4-11.1l1.7-0.1h24.7l34.3,11l1.2,0.5l1,0.9l36.3,36.8l0.4,8.9l0.1,3L201,117.3l0.9,11.1L177,171.7 c-3.7,4.3-32.5,32.7-32.9,33.1C139.7,209.5,134.8,215.8,125.6,215.8L125.6,215.8z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
                    />
                </g>
                <g id="persistent_1_">
                    <g id="mound_1_">
                        <path
                            id="pitching-mound_1_"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber_1_"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines_1_">
                        <path
                            id="left-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2l-98.9-98.9"
                        />
                        <path
                            id="right-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2l98.4-98.5"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3661 122.8889)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1129 157.4789)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4747 132.5383)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue2889
